import qs from 'qs';
import oikosApi from '../../../services/oikos';
import { TP_DOCUMENTO_MINUTA_CONTRATO } from '../../../pages/MeusFornecedores/contratosTabHelpers';
import { getContrFornDocumentosObrigatoriosIds } from './contrFornExtendedFields';
import { getCadastroSections } from './contrFornCompraCotacaoInfo';

export { TP_DOCUMENTO_MINUTA_CONTRATO };

/**
 * Modelo de minuta "Fornecedor" — detectado pelo label do select tpMinuta
 * (case-insensitive, match exato ou contendo "fornecedor").
 */
export const isTpMinutaFornecedor = (tpMinutaId, selTiposDeMinuta = []) => {
  const id = Number(tpMinutaId) || 0;
  if (!id) return false;

  const option = (selTiposDeMinuta || []).find((item) => Number(item.value) === id);
  const label = String(option?.label || option?.tpMinuta_nome || '').trim().toLowerCase();
  if (!label) return false;

  return label === 'fornecedor' || label.includes('fornecedor');
};

/** Une ids já selecionados com tpDocumento 20 quando a minuta é do fornecedor. */
export const mergeMinutaFornecedorDocIntoHashIds = (
  documentosIds = [],
  { tpMinutaId, selTiposDeMinuta = [], tpMinutaNome } = {},
) => {
  const base = (Array.isArray(documentosIds) ? documentosIds : [])
    .map((id) => Number(id))
    .filter((id) => Number.isFinite(id) && id > 0);

  const unique = [...new Set(base)];

  const isFornecedor = tpMinutaNome != null && String(tpMinutaNome).trim() !== ''
    ? (() => {
      const label = String(tpMinutaNome).trim().toLowerCase();
      return label === 'fornecedor' || label.includes('fornecedor');
    })()
    : isTpMinutaFornecedor(tpMinutaId, selTiposDeMinuta);

  if (!isFornecedor) return unique;
  if (unique.includes(TP_DOCUMENTO_MINUTA_CONTRATO)) return unique;
  return [...unique, TP_DOCUMENTO_MINUTA_CONTRATO];
};

export const resolveDocumentosIdsForContratacaoHash = (
  contrFornData = {},
  { selTiposDeMinuta = [], tpMinutaNome } = {},
) => (
  mergeMinutaFornecedorDocIntoHashIds(
    getContrFornDocumentosObrigatoriosIds(contrFornData),
    {
      tpMinutaId: contrFornData.tpMinuta_id,
      selTiposDeMinuta,
      tpMinutaNome: tpMinutaNome ?? contrFornData.tpMinuta_nome,
    },
  )
);

/** Localiza anexo de minuta (tpDocumento 20) no compraCotacao_info do fornecedor. */
export const findMinutaFornecedorDocFromInfo = (info) => {
  const sections = getCadastroSections(info);
  const docs = sections?.documentosObrigatorios || [];
  const matches = docs.filter(
    (doc) => Number(doc?.tpDocumento_id) === TP_DOCUMENTO_MINUTA_CONTRATO,
  );
  if (!matches.length) return null;

  const withId = matches
    .filter((doc) => Number(doc.documento_id) > 0)
    .sort((a, b) => (Number(b.documento_id) || 0) - (Number(a.documento_id) || 0));

  return withId[0] || matches[0] || null;
};

/** Garante documentoVinc da minuta do fornecedor ao contrForn (para Download). */
export const ensureMinutaDocumentoVincToContrForn = async (documentoId, contrFornId) => {
  const docId = Number(documentoId) || 0;
  const contrId = Number(contrFornId) || 0;
  if (!docId || !contrId) {
    throw new Error('Minuta do fornecedor ou contrato inválidos para vinculação.');
  }

  const existing = await oikosApi.get(`/?${qs.stringify({
    action: 'get',
    table: 'documentoVinc',
    data: {
      documento_id: docId,
      documentoVinc_tabRef: 'contrForn',
      documentoVinc_tabId: contrId,
    },
    fields: {
      documentoVinc_id: 'documentoVinc_id',
    },
  })}`);

  if ((existing?.data || []).length > 0) return existing.data[0];

  const created = await oikosApi.post('/', {
    action: 'insert',
    table: 'documentoVinc',
    data: {
      documento_id: docId,
      documentoVinc_tabRef: 'contrForn',
      documentoVinc_tabId: contrId,
    },
  });

  return created?.data?.[0] || null;
};
